<template>
	<div class="page">
		<top-header></top-header>
		<b-container fluid >
		<b-row class="mb-3">
			<top-nevleft></top-nevleft>
			
		 <b-col >
			<!-- <b-row class="breadcrumbrow mt-1 m-0">				
				<b-col>
				 <h5 class="text-center">Seller Dashboard</h5>
				</b-col>				
			</b-row> -->
		
		<b-container fluid class="p-0 mt-2">
			<b-tabs content-class="mt-3" fill pills  class="profileTab">
				<b-tab title="Brands" active>
					<b-row class="mt-3 mb-2 m-0">
						<b-col class="col-md-6 col-sm-6 col-xs-6 text-left">
							<!--<h3>Manage Brands</h3> -->
						</b-col>
						<b-col class="col-md-6 col-sm-6 col-xs-6 text-right">
							<b-button variant="dark" pill class="mr-2" @click="showAddModal()"><b-icon class="mr-2" icon="plus" aria-hidden="true"></b-icon>Add Brand</b-button>
							
						</b-col>
					</b-row>
				<b-container fluid class="my-2">
				<b-row class="m-0">
					<b-col class="col-md-12 col-sm-12 col-xs-12">
						<div class="container-box">
							<b-row class="mt-4 px-3">
								<b-col lg="6" class="text-left">
									<span class="mr-2">Show</span>
									<b-form-select v-model="perPage" id="perPageSelect" :options="pageOptions" size="sm" class="w-25">
									</b-form-select>
									<span class="ml-2">entries</span>
								</b-col>
								<b-col lg="4" offset-md="2">
									<b-form-group label="Filter" label-cols-sm="3" label-align-sm="right" label-size="sm" label-for="filterInput" class="mb-0">
										<b-input-group size="sm">
											<b-form-input v-model="filter" type="search" id="filterInput" placeholder="Type to Search">
											</b-form-input>
											<b-input-group-append>
												<b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
											</b-input-group-append>
										</b-input-group>
									</b-form-group>
								</b-col>
							</b-row>
							<b-row class="px-3 pt-3">
								<b-col lg="12">
									<b-table show-empty sticky-header small striped outlined id="my-table" stacked="md" :items="records" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :filterIncludedFields="filterOn" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered">
										
										<!--<template v-slot:cell(actions)="row">
											<b-button pill variant="primary" class="mr-1 icon-btn" @click="showUpdateModal(row.item, row.index, $event.target)"><b-icon icon="pencil" font-scale="1.6" ></b-icon></b-button>
											<b-button pill variant="danger" class="mr-1 icon-btn" @click="showDeleteModal(row.item)"><b-icon icon="trash" font-scale="1.6" ></b-icon></b-button>
										</template> -->
										<template v-slot:cell(status)="row">
											<b-badge pill variant="warning" v-if="row.value == 0">In Active</b-badge>
											<b-badge pill variant="success" v-else>Active</b-badge>										
										</template>
										<template v-slot:cell(brand_logo)="row">
											<b-img v-bind="thumbnailProps" rounded alt="" v-if="row.value==''" :src="$root.MEDIAPATH+'blank.jpg'">{{row}}</b-img>
											<b-img v-bind="thumbnailProps" rounded alt="" v-else :src="$root.MEDIAPATH+'brands/'+row.value.replace('_rg','_th')">{{row}}</b-img>
										</template>
										<template v-slot:cell(actions)="row">
											<b-button pill variant="outline-primary" class="mr-1 icon-btn" @click="showUpdateModal(row.item, row.index, $event.target)"><b-icon icon="pencil" font-scale="1.6" ></b-icon></b-button>
											<b-button pill variant="outline-danger" class="mr-1 icon-btn" @click="showDeleteModal(row.item)"><b-icon icon="trash" font-scale="1.6" ></b-icon></b-button>
										</template>
									</b-table>
								</b-col>
							</b-row>
							<b-row class="px-3">
								<b-col lg="6" class="text-left">
									<span class="mr-2">Showing {{currentPage}} to {{(perPage>records.length)?records.length:perPage}} of {{records.length}} entries</span>
								</b-col>
								<b-col lg="3" offset-md="3">
									<b-pagination v-model="currentPage" pills :total-rows="totalRows" :per-page="perPage" align="right" size="sm" prev-text="Prev" next-text="Next" first-number last-number></b-pagination>
								</b-col>
							</b-row>
						</div>
					</b-col>
				</b-row>
				
				
					<b-modal id="my-model" :title="(selectedItem.id > 0)?'Edit Brand':'Add Brand'" size="lg" ok-only @hidden="resetSelectedItem" @ok="modalSubmit">
						<form ref="form" @submit.stop.prevent="handleSubmit">
							<b-container fluid>
								<b-tabs content-class="mt-3" small>
									<b-tab title="Brand" href="#product">
										<b-row class="mb-1">
											<b-col cols="12">
												<b-row class="mb-3">
													<b-col cols="3" class="text-right">
													<label class="font-sm">Brand Name</label></b-col>
													<b-col>
													
													<!--<b-form-input v-model="selectedItem.brand_name" size="sm" :maxlength="100" required ></b-form-input>-->
													<b-form-group :state="selectedItemState.brand_name"  label-for="brandName-input" label-size="sm" label-class="mb-0" class="mb-1" invalid-feedback="Brand name is required!" >
														<b-form-input v-model="selectedItem.brand_name" size="sm" :maxlength="100" id="brandName-input" :state="selectedItemState.brand_name" @focusin="selectedItemState.brand_name = null" ></b-form-input>
													</b-form-group>
													
													</b-col>
													
												</b-row>
												<b-row class="mb-3">
													<b-col cols="3" class="text-right"><label class="font-sm">About Brand</label></b-col>
													<b-col>
														<b-form-textarea v-model="selectedItem.about_brand" size="sm" rows="3" :maxlength="250" required></b-form-textarea>
														<small class="float-right">{{250-selectedItem.about_brand.length}}/250 Character Remaining</small>	
													</b-col>
													
												</b-row>
												<b-row class="mb-3">
													<b-col cols="3" class="text-right"><label class="font-sm">Brand Logo</label></b-col>
													<b-col>
														<b-form-file type="file" v-model="product_inf.product_image_1" accept=".jpeg,.jpg,.png" size="sm" placeholder="Choose a Image"></b-form-file>
														<b-form-text id="password-help-block">{{selectedItem.brand_logo}}</b-form-text>
													</b-col>
												</b-row>
												
												<b-row class="mb-3">
													<b-col cols="3" class="text-right"><label class="font-sm">Status</label></b-col>
													<b-col cols="4">
														<!-- <b-form-select v-model="selectedItem.status" size="sm" required>
															<b-form-select-option value="1">Active</b-form-select-option>
															<b-form-select-option value="2">In Active</b-form-select-option>
														</b-form-select> -->
														
														<b-form-group :state="selectedItemState.status"  label-for="bannerstatus-input" label-size="sm" label-class="mb-0" class="mb-1" invalid-feedback="Status is required!">
															<b-form-select v-model="selectedItem.status" id="bannerstatus-input" :state="selectedItemState.status" v-on:change="selectedItemState.status = null">
															<b-form-select-option value="" hidden selected placeholder="select State">*Select status</b-form-select-option>
															<b-form-select-option value="1">Active</b-form-select-option>
															<b-form-select-option value="2">In Active</b-form-select-option>
															</b-form-select>
														</b-form-group>
															
														
														
													</b-col>
												</b-row>
												
												
											</b-col>
										</b-row>
									</b-tab>
								</b-tabs>
								
							</b-container>
						</form>
						<template v-slot:modal-footer="{ ok, close }">
							<b-button size="sm" variant="danger" @click="close()">Cancel</b-button>
							<!-- <b-button size="sm" variant="success" @click="ok()">{{(selectedItem.id > 0)?'Update':'Submit'}}</b-button>-->
							<b-button size="sm" variant="success" @click="modalSubmit">{{(selectedItem.id > 0)?'Update':'Submit'}}</b-button>
						</template>
					</b-modal>			
			</b-container>

				</b-tab>

				<b-tab title="Brand Banners" >
						<brand-banner :brands="records"></brand-banner>
				</b-tab>
			
			
		  </b-tabs>
			
		
			
		</b-container>
		<transition name="fade">
			<b-row v-if="loading" class="loading" style="position: absolute; top:0px; left:0px; right:0px; bottom:0px; z-index: 1000; background-color: rgba(0,0,0,0.4);" align-v="center" align-h="center">
				<b-spinner label="Busy" variant="light"></b-spinner>
			</b-row>
		</transition>
			<top-footer></top-footer>
		</b-col>
		</b-row>
		</b-container>
	
	</div>
	
</template>
<script>
import '@/assets/profileuser.scss';
//import Header from "@/components/seller/Header.vue";
import Header from "@/components/header.vue";
import TreeviewPage from "@/components/seller/nevleft.vue";
import Footer from "@/components/footer-admin.vue";
import BrandBanner from "@/components/brand-banner.vue";
export default {
	name: 'Devices',
	components: {
		"top-header": Header,
		"top-footer": Footer,
		"top-nevleft": TreeviewPage,
		"brand-banner": BrandBanner,
	},
	mounted(){
		//var self = this;
		//Object.assign(self.selectedItem, self.emptyItem);
		this.initload();
	},
	data() {
		return{
            loading: true, 
            thumbnailProps: { blank: false, width: 60, height: 60, class: 'm1' },
            product_inf: {},
		
			/*product_glb: '',*/
			model_maps: {},
			recordUrl: this.$root.WEBAPI+'sellerapi/brand-record',
			//insertUrl: this.$root.WEBAPI+'sellerapi/brand-insert',
			insertUrl: this.$root.NEWAPIURL+'sellerapi/brand-insert',
			updateUrl: this.$root.NEWAPIURL+'sellerapi/brandupdate',
			deleteUrl: this.$root.WEBAPI+'sellerapi/brand-delete',
			csvgenUrl: this.$root.WEBAPI+'sellerapi/product-csvgen',
			filteredCategory: [],
			category: [],
			records: [],
			categoryOptions: [],
			breadcrumb: [
				{
					text: 'Home',
					href: '/'
				},
				{
					text: 'Brands',
					active: true
				}
			],
			fields: [
				{ key: 'id', label: 'ID'},
				{ key: 'brand_name', label: 'Name'},				
				{ key: 'brand_logo', label: 'Logo'},
				{ key: 'status', label: 'Status' },
				{ key: 'actions', label: 'Actions', 'extra': 1, class: 'text-right' }
			],
			totalRows: 1,
			currentPage: 1,
			pageOptions: [10, 20, 50, 100],
			perPage: 10,
			sortBy: '',
			sortDesc: false,
			sortDirection: 'asc',
			filter: null,
			filterOn: [],
			selectedItem: {
				brand_name: '',
				about_brand: '',
				status: '',
				short_description: '',
				product_data:{}, 
				tier_price:[], 
				gallery_images:[""]
			},
			selectedItemState: {
				brand_name:null,
				about_brand:null,
				status:null,
			},
			emptyItem: {
				id: 0,
				brand_name: '',
				about_brand: '',
				brand_logo: '',
				gallery_images:[""],
                status: 0
			},
			counterindex:1
		};
	},
	methods: {		
		showAddModal(){
			this.selectedItem = Object.assign({}, this.emptyItem);
			this.$root.$emit('bv::show::modal', 'my-model');
		},
		showUpdateModal(item, index, button) {
			this.selectedItem = Object.assign({}, item);
			if(item.product_data){
				this.selectedItem.product_data = JSON.parse(item.product_data);
			}
			if(item.tier_price){
				this.selectedItem.tier_price = JSON.parse(item.tier_price);
			}
			
			this.$root.$emit('bv::show::modal', 'my-model', button)
		},
		showCsvModal(item){
			var self = this;
			this.$bvModal.msgBoxConfirm('Please confirm that you want to generate product csv!.', {
				title: 'Please Confirm',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'success',
				okTitle: 'YES',
				cancelTitle: 'NO',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			})
			.then(value => {
				if(value == true){
					self.axios.post(self.csvgenUrl, {
						accesskey: self.$session.get('access_key'),
						product_id: item.id
					})
					.then(function (response) {
						if(response.data.error == 0 || response.data.error == '0'){

							self.$bvToast.toast(response.data.message, {
								title: 'Delete',
								toaster: 'b-toaster-bottom-right',
								autoHideDelay: 5000,
								variant: 'warning',
								solid: true,
								appendToast: true
							});
							
							
						}
						
					})
					.catch(function (error) {
						alert(error);
					});
				}else{
					//alert('no '+item.id);
				}
			})
			.catch(err => {
				// An error occurred
				console.log(err);
			})
		},
		showDeleteModal(item){
			var self = this;
			this.$bvModal.msgBoxConfirm('Please confirm that you want to delete Brand!.', {
				title: 'Please Confirm',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: 'YES',
				cancelTitle: 'NO',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			})
			.then(value => {
				if(value == true){
					self.axios.post(self.deleteUrl, {
						accesskey: self.$session.get('access_key'),
						delete_id: item.id
					})
					.then(function (response) {
						if(response.data.error == 0 || response.data.error == '0'){
							self.$bvToast.toast(response.data.message, {
								title: 'Delete',
								toaster: 'b-toaster-bottom-right',
								autoHideDelay: 5000,
								variant: 'warning',
								solid: true,
								appendToast: true
							});
							self.initload();
						}
						
					})
					.catch(function (error) {
						alert(error);
					});
				}else{
					//alert('no '+item.id);
				}
			})
			.catch(err => {
				// An error occurred
				console.log(err);
			})
		},
		modalSubmit(bvModalEvt){
			var valid = true;
			if(this.selectedItem.brand_name=='') {
				this.selectedItemState.brand_name = false;
				valid = false;
			}else this.selectedItemState.brand_name = true;
			
			
			
			if(this.selectedItem.status=='') {
				this.selectedItemState.status = false;
				valid = false;
			}else this.selectedItemState.status = true;
		
		
			if(valid){
				var self = this;
				self.loading = true;
				bvModalEvt.preventDefault();
				var submitUrl = "";
				if(self.selectedItem.id == 0){
					submitUrl = self.insertUrl;
				}else{
					submitUrl = self.updateUrl;
				}

				let formData = new FormData();
				formData.append('imagefile1', this.product_inf.product_image_1);
				/*formData.append('imagefile2', this.product_inf.product_image_2);
				formData.append('imagefile3', this.product_inf.product_image_3);
				formData.append('imagefile4', this.product_inf.product_image_4);*/
				formData.append('data', JSON.stringify(this.selectedItem));
				formData.append('accesskey', this.$session.get('access_key'));

				self.axios.post(submitUrl, formData, {
					headers: {
						'Content-Type': 'multipart/form-data'
					}
				})
				.then(function (response) {
					if(response.data.error == 0 || response.data.error == '0'){
						self.$bvModal.hide('my-model');
						self.$bvToast.toast(response.data.message, {
							title: 'Status',
							toaster: 'b-toaster-bottom-right',
							autoHideDelay: 5000,
							variant: 'warning',
							solid: true,
							appendToast: true
						});
						self.product_inf.product_image_1 = '';
						self.selectedItemState={
							brand_name:null,
							about_brand:null,
							status:null,
						},
						
						self.initload();
					}
					
				})
				.catch(function (error) {
					alert(error);
				});
			
			}
		},
		
		

		resetSelectedItem(){
			var self = this;
			self.selectedItem = Object.assign({}, self.emptyItem);
		},
		initload(){
			var self = this;
			
			self.axios.post(self.recordUrl, {
				accesskey: self.$session.get('access_key')
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.records = response.data.result.products;
					console.log(self.records);
					//self.category = response.data.result.category; 
					self.loading = false;
					self.totalRows = self.records.length;

					self.filteredCategory = [];
					//self.filterChildCategory(0, 0, 0);
				}else if(response.data.error == 9){
					self.$root.forceLogout(response.data.message);
				}
				//setTimeout(self.initload, 1000*30);
			})
			.catch(function (error) {
				alert(error);
			});
			//alert('login '+self.email+" "+self.password);
		},
		/*filtercategory(records){
			var filterarr = new Array();
			records.forEach(function(row){
				var dataarr = new Array();
				self.fields.forEach(function(field){
					if(field.key != 'extra'){
						dataarr.push(row[field.key]);
					}
				});
				finalarr.push(dataarr);
			});
		},*/
		onFiltered(filteredItems) {
			this.totalRows = filteredItems.length
			this.currentPage = 1
		},
	}
}
</script>
<style>
</style>